import React from "react";
import ReactDOM from "react-dom";
import ReactSound from "./Components/general/react/ReactSound";
import ReactCaption from "./Components/general/react/ReactCaption";
import SoundProps from "./Misc/SoundProps";
import Tools from "./Misc/Tools";
import SoundManager from "./SoundManager";

export default class ReactSoundManager extends SoundManager<React.FunctionComponentElement<SoundProps>> {
	constructor(public onActiveSoundsUpdated: () => void) {
		super(onActiveSoundsUpdated);
	}

	protected onAppendSoundToDOM(sound: SoundProps): React.FunctionComponentElement<SoundProps> {
		return React.createElement(ReactSound, { ...sound, key: Tools.generateGuid() } as any);
	}

	render() {
		const soundRef = this.activeSounds.map(s => s.reference);
		const notEmptySoundRef = soundRef.length;
		return (
			<>
				<ReactCaption
					currentCaption={SoundManager.currentCaption}
					activeSounds={this.activeSounds}
				></ReactCaption>
				{notEmptySoundRef ? this.activeSounds.map(s => s.reference) : <ReactSound/>}
			</>
		);
	}
}